import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalstorageService } from '../storage/localstorage.service';

@Injectable({
  providedIn: 'root'
})

export class AmbienteSefazService {

  constructor(public localStorage:LocalstorageService) { }

  private statusSubject = new BehaviorSubject<boolean>(true)
  status$ = this.statusSubject.asObservable();

  setStatus(newStatus: boolean){
    this.localStorage.setData('SFZPRDMHL', newStatus)
    this.statusSubject.next(newStatus);
  }

  loadStatus(){
    const value = this.localStorage.getData('SFZPRDMHL');
  if (value !== null) {
    this.statusSubject.next(JSON.parse(value));
  }
  }
}
